import { Component, inject, signal } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { UpdateService } from './commons/services/Update.Service';

@Component({
  selector: 'oaj-app-root',
  imports: [
    RouterOutlet
  ],
  templateUrl: './app.html',
  styleUrl: './app.css',

})
export class App {
  protected readonly title = signal('OAJ-ICOIJ-Web-Interconexion');
private swUpdate: UpdateService = inject(UpdateService);

  constructor() {
    // Verifica el service worker para actualizaciones
   // console.log('Verificando actualizaciones del service worker...');
    this.swUpdate.checkForUpdates();
  }
}
